
riot.tag2('sms-templates', '  <catalog search="true" sortable="true" object="SmsTemplate" cols="{cols}" reload="true" add="{permission(add, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;settings&quot;, &quot;1000&quot;)}" store="sms-templates">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.mixin('permissions');

self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'name', value: 'Наименование' }];

self.add = function () {
    riot.route('/settings/sms/new');
};

self.open = function (e) {
    riot.route('/settings/sms/' + e.item.row.id);
};

observable.on('sms-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/sms/sms-templates.tag